module.exports = __webpack_public_path__ + "img/payment-right.9219e804.png";